import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`payment-type`, model)
    },
    async fetchById(id) {
        return await axios.get(`payment-type/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`payment-type?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`payment-type/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`payment-type/${id}`)
    },
}
